import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import {
  Button,
  Card,
  IconButton,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Box from "@mui/material/Box";
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import { isValidInput } from "../../utils/validations";
import {
  useChangeSubscriptionStatusMutation,
  useDeleteSubscriptionMutation,
} from "../../services/subscription";
import { CommonBody, Subscription } from "../../types/General";
import { showError, showToast } from "../../constants";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import WarnModal from "../../components/WarnModal";
import useAuth from "../../hooks/useAuth";
import useTranslation from "../../hooks/Translation";
import {
  useDeleteDiscountMutation,
  useLazyGetAllDiscountQuery,
} from "../../services/discount";
import moment from "moment";
import Pagination from "../../components/Pagination";

const ManageDiscount = () => {
  const navigate = useNavigate();
  const userData = useAuth();
  console.log(userData);
  const [getDiscountsQuery, { isLoading }] = useLazyGetAllDiscountQuery();
  const [subscriptionStatus] = useChangeSubscriptionStatusMutation();
  const [deleteDiscount] = useDeleteDiscountMutation();
  const [totalCount, setTotalCount] = useState<number>(0);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [discountData, setDiscountData] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [page, setPage] = useState(1);
  const [selectedId, setSelectedId] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);

  const [hidePermission, setHidePermission] = useState<any>({
    isAdd: true,
    isDelete: true,
  });
  console.log(hidePermission, "hidePermission");
  const translate = useTranslation();

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };
  let totalPages = Math.ceil(totalCount / 10);

  const getDiscounts = async () => {
    try {
      const response = await getDiscountsQuery({
        query: debouncedSearchTerm.trim(),
        page: page,
      }).unwrap();
      if (response?.statusCode === 200) {
        setDiscountData(response?.data?.data);
        setTotalCount(response?.data?.total);
      } else {
        setDiscountData([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const handleDelete = async (id: string) => {
    try {
      const response = await deleteDiscount({ id: id }).unwrap();
      if (response?.statusCode === 200) {
        showToast("Promo Code deleted successfully");
        getDiscounts();
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const updateUserStatus = async (id: string, status: boolean) => {
    const data = {
      isBlocked: status,
    };

    let encryptedBody = generateEncryptedKeyBody(data) as CommonBody;

    const response = await subscriptionStatus({
      encryptedBody,
      subsId: id,
    }).unwrap();
    if (response?.statusCode === 200) {
      const updatedData = discountData?.map((x: any) => {
        if (x._id === id) {
          return {
            ...x,
            isBlocked: status,
          };
        }
        return x;
      });
      setDiscountData(updatedData);
      showToast("Status updated successfully");
    } else {
      showError("Please try again");
    }
  };

  const formatNumberWithCommas = (number: any) => {
    if (number > 0) {
      const formattedNumber = number.toLocaleString("en-IN");
      return `${formattedNumber}`;
    }
    return "";
  };

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const checkPermission = () => {
    const permissions = userData?.permission;
    if (permissions?.length) {
      let idx = -1;
      idx = permissions?.findIndex(
        (ele: any) => ele?.name === "Manage Promotional Code"
      );

      if (idx != -1) {
        let data = {
          isAdd: permissions[idx]?.isAdd,
          isDelete: permissions[idx]?.isDelete,
        };
        setHidePermission(data);
      }
    }
  };

  useEffect(() => {
    if (userData && userData?.permission?.length) {
      checkPermission();
    }
  }, [userData]);

  useEffect(() => {
    getDiscounts();
  }, [page, debouncedSearchTerm]);

  return (
    <MainContainer>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng"> Manage Promotional Code</h1>
        </div>
        <Card className="cards">
          <Box className="cards_header">
            <SearchBar
              value={searchTerm}
              searchTerm={searchTerm}
              onCross={() => setSearchTerm("")}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
            <Box className="cards_header_right">
              {hidePermission?.isAdd ? (
                <Button
                  className="btn btn_primary"
                  onClick={() => navigate("/manage-discount/add")}
                >
                  Add Promotional Code
                </Button>
              ) : null}
            </Box>
          </Box>
          <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">{translate?.main?.SNo}</TableCell>
                  <TableCell>Discount Code</TableCell>
                  <TableCell>Discount Name</TableCell>
                  <TableCell>Discount Type</TableCell>
                  <TableCell>Coupon type</TableCell>
                  <TableCell>Discount Value</TableCell>
                  <TableCell>Min Amount To Apply</TableCell>
                  <TableCell>Start Date</TableCell>
                  <TableCell>End Date</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>{translate?.main?.Action}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {discountData?.length > 0 ? (
                  discountData?.map((row: any, i: any) => (
                    <TableRow key={row?._id}>
                      <TableCell align="center">{i + 1}</TableCell>
                      <TableCell>{row?.discountCode || "-"}</TableCell>
                      <TableCell>{row?.discountName || "-"}</TableCell>
                      <TableCell>
                        {row?.discountType === 1 ? "Percentage" : "Flat"}
                      </TableCell>
                      <TableCell>
                        {row?.couponType === 1
                          ? "Highlighted"
                          : row?.couponType === 2
                          ? "Normal"
                          : "Both"}
                      </TableCell>
                      <TableCell>{row?.discountValue || "-"}</TableCell>
                      <TableCell>{row?.minAmountToApply || "-"}</TableCell>
                      <TableCell>
                        {moment(row?.startDate).format("MM-D-YY")}
                      </TableCell>
                      <TableCell>
                        {moment(row?.endDate).format("MM-D-YY")}
                      </TableCell>

                      <TableCell>
                        <Switch
                          {...label}
                          size="small"
                          checked={!row?.isBlocked}
                          onChange={() =>
                            updateUserStatus(row?._id, !row?.isBlocked)
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <Box className="table_actions">
                          {hidePermission?.isAdd ? (
                            <IconButton
                              onClick={() =>
                                navigate(`/manage-discount/edit/${row?._id}`)
                              }
                            >
                              <ModeEditIcon />
                            </IconButton>
                          ) : null}
                          {hidePermission?.isDelete ? (
                            <IconButton
                              onClick={() => {
                                setOpen(true);
                                setSelectedId(row?._id);
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          ) : null}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      No Promotional Code Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
        {discountData?.length > 0 ? (
          <Pagination
            setPage={setPage}
            module={discountData}
            page={page}
            onPageChange={onPageChange}
            totalPages={totalPages}
          />
        ) : (
          ""
        )}
      </div>
      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => handleDelete(selectedId)}
        name="Code"
      />
    </MainContainer>
  );
};

export default ManageDiscount;
